import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import { L1L3AuthService } from './l1-l3-auth.service';

@Injectable({providedIn: 'root'})
export class TokenRefreshService {
  private refreshTokenPending: boolean = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private l1l3AuthService: L1L3AuthService) {
  }

  public startRefresh(): BehaviorSubject<any> {
    if (!this.refreshTokenPending) {
      this.refreshTokenPending = true;
      this.refreshTokenSubject.next(null);
    }

    const l1Token = this.l1l3AuthService?.getL1Token();
    if (!l1Token) {
      console.log('Log out --> no l1');
      this.l1l3AuthService?.logout();
    }
    if (this.l1l3AuthService.isJWTTokenExpired(l1Token.access_token)) {
      console.log('401 - refreshing l1');
      this.refreshL1();
    } else {
      // valid l1 access token
      const l3Token = this.l1l3AuthService?.getL3Token();
      if (!l3Token) {
        console.log('401 - request l3');
        this.requestL3();
      } else {
        if (this.l1l3AuthService.isJWTTokenExpired(l3Token.access_token)) {
          // invalid l3 access token
          console.log('l3 access is expired');
          if (this.l1l3AuthService.isJWTTokenExpired(l3Token.refresh_token)) {
            // invalid l3 refresh token
            console.log('&& l3 refresh is expired');
            this.requestL3();
          } else {
            // valid l3 refresh token
            console.log('401 - refreshing l3');
            this.refreshL3();
          }
        } else {
          // valid l3 access token
          console.log('401 - tokens should be valid');
          this.refreshTokenPending = false;
          this.refreshTokenSubject.next(l3Token.access_token);
        }
      }
    }
    return this.refreshTokenSubject;
  }

  public isRefreshTokenPending(): boolean {
    return this.refreshTokenPending;
  }

  public getRefreshTokenSubject(): BehaviorSubject<any> {
    return this.refreshTokenSubject;
  }

  private refreshL1(): void {
    console.log('Refresh L1');
    if (this.l1l3AuthService.isJWTTokenExpired(this.l1l3AuthService?.getL1Token()?.refresh_token)) {
      console.log('Log out --> l1 refresh expired');
      this.l1l3AuthService?.logout();
    } else {
      this.l1l3AuthService.refreshL1Token().subscribe({
        next: (token: any) => {
          console.log('refresh l1 ===> next');
          this.refreshTokenPending = false;
          this.refreshTokenSubject.next(token.access_token);
        },
        error: (error: any) => {
          console.log('refresh l1 ===> catcherror');
          console.log('Log out', error);
          this.l1l3AuthService?.logout();
        }
      });
    }
  }

  private refreshL3(): void {
    console.log('Refresh L3');
    this.l1l3AuthService.refreshL3Token().subscribe({
      next: token => {
        console.log('Refresh L3 ===> next');
        this.refreshTokenPending = false;
        this.refreshTokenSubject.next(token.access_token);
      },
      error: error => {
        console.log('Refresh L3 ===> catch error');
        if (this.isAuthenticationError(error) || this.is400Error(error)) {
          this.requestL3();
        } else {
          console.log('Log out', error);
          this.l1l3AuthService?.logout();
        }
      }
    });
  }

  private requestL3(): void {
    console.log('Request L3');
    this.l1l3AuthService.requestL3Token().subscribe({
      next: token => {
        console.log('Request l3 ===> next');
        this.refreshTokenPending = false;
        this.refreshTokenSubject.next(token.access_token);
      },
      error: error => {
        console.log('Request l3 ===> catch error');
        if (this.isAuthenticationError(error) || this.is400Error(error)) {
          this.refreshL1();
        } else {
          console.log('Log out', error);
          this.l1l3AuthService?.logout();
        }
      }
    });
  }

  private isAuthenticationError(error: any): boolean {
    return error instanceof HttpErrorResponse && error?.status === 401;
    // && this.isSecuredHost(request?.url)
    // && request?.url.indexOf('logout') === -1;
  }

  private is400Error(error: any): boolean {
    return error instanceof HttpErrorResponse && error?.status === 400;
    // && this.isSecuredHost(request?.url)
    // && request?.url.indexOf('logout') === -1;
  }

}
